import React from 'react'
import PrintComponent from './Print'

const Invoice = () => {
  return (
    <div><PrintComponent /></div>
  )
}

export default Invoice